import { render, staticRenderFns } from "./ProductBarInTopic.vue?vue&type=template&id=0cbc9aaa&"
import script from "./ProductBarInTopic.vue?vue&type=script&lang=js&"
export * from "./ProductBarInTopic.vue?vue&type=script&lang=js&"
import style0 from "./ProductBarInTopic.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports